import axios from 'axios';
import { ApiResponse } from '@/types/ApiResponse';
import { PublicKeyResponse } from '@/types/user/response/PublicKeyResponse';
import { LoginResponse } from '@/types/user/response/LoginResponse';
import { UserLoginRequest } from '@/types/user/request/UserLoginRequest';
import { UserServiceBasePath } from './BaseServicePath';
import { UserListRequest } from '@/types/user/request/UserListRequest';
import { UserResponseList } from '@/types/user/response/UserResponseList';
import { UserRequest } from '@/types/user/request/UserRequest';
import { UserResponse } from '@/types/user/response/UserResponse';
class UserService{
    getPublicKey = async () => {
        const response = await axios.get<ApiResponse<PublicKeyResponse>>(UserServiceBasePath + "/v1/userservice/get_public_key")
        return response.data
    }

    userlogin = async (userLoginRequest:UserLoginRequest) => {
        const response = await axios.post<ApiResponse<LoginResponse>>(UserServiceBasePath + "/v1/userservice/login", userLoginRequest)
        return response.data
    }

    // 获取用户列表 API
    getUserList = async (userListRequest:UserListRequest) => {
        const response =await axios.post<ApiResponse<UserResponseList>>(UserServiceBasePath+'/v1/userservice/getuserlist',userListRequest);
        return response.data;
    };

    // 更改用户的status
    updateUserStatus = async (userRequest:UserRequest) => {
        const response =await axios.post<ApiResponse<UserResponse>>(UserServiceBasePath+'/v1/userservice/controlluserstatus',userRequest);
        return response.data;
    }

    
}

export const userService = new UserService()